module.exports = __webpack_public_path__ + "static/media/learning-23.8d0efb15.png";